import React, { FC } from 'react';

import { Space as AntdSpace, SpaceProps as AntdSpaceProps } from 'antd';

interface Props extends AntdSpaceProps {
  fullWidth?: boolean;
}

const Space: FC<Props> = (props) => {
  const { fullWidth = true, style, ...rest } = props;
  return (
    <AntdSpace
      {...rest}
      style={{
        width: fullWidth ? '100%' : undefined,
        ...style,
      }}
    />
  );
};

export default Space;
